import React from "react";

export default function NewAbout(props) {
  return (
    <>
      <section className="about-strip inter">
        {/* CONTENT */}
        <div className="about-strip-content">
          <h2 className="about-strip-title">
            About {props?.partner?.partner_name || "Our Partner"}
          </h2>

          <p className="about-strip-text">
            {props?.partner?.partner_name || "Company"} now offers innovative
            Buy-Before-You-Sell solutions powered by Calque, a fintech company
            that provides a binding backup contract-known as a Guaranteed Backup
            Agreement (GBA) on a borrower’s home. This enables loan officers to eliminate home sale contingencies,
            enabling borrowers to submit stronger offers with the confidence
            that their current home will sell no matter what. Calque is not a
            lender-think of us as a backup buyer, providing greater convenience,
            confidence, and success throughout the process.
          </p>
        </div>
      </section>

      {/* STYLES */}
      <style>{`
        /* FULL WIDTH STRIP */
        .about-strip {
          width: 100vw;
          min-height: 300px; /* THIN */
          display: flex;
          align-items: center;
          background-image: url("/assets/images/about_section_image.png");
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          position: relative;
        }

        /* SOFT FADE FOR READABILITY (NOT A BACKGROUND COLOR) */
        .about-strip::before {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(
            90deg,
            rgba(255,255,255,0.92) 0%,
            rgba(255,255,255,0.85) 40%,
            rgba(255,255,255,0.4) 60%,
            rgba(255,255,255,0) 75%
          );
          z-index: 1;
        }

        /* CONTENT */
        .about-strip-content {
          max-width: 1200px;
          padding: 18px 64px;
          z-index: 2;
        }

        .about-strip-title {
          color: #1B3964;
          font-size: 40px;
          font-weight: 700;
          margin-bottom: 20px;
        }

        .about-strip-text {
          color: #010E1D;
          font-size: 16px;
          line-height: 24px;
          max-width: 520px;
        }

        /* RESPONSIVE */
        @media (max-width: 992px) {
          .about-strip {
            min-height: 260px;
          }

          .about-strip-content {
            padding: 40px 32px;
          }

          .about-strip-title {
            font-size: 32px;
          }
        }

        @media (max-width: 576px) {
          .about-strip {
            min-height: 220px;
          }

          .about-strip::before {
            background: linear-gradient(
              180deg,
              rgba(255,255,255,0.95) 0%,
              rgba(255,255,255,0.75) 50%,
              rgba(255,255,255,0) 100%
            );
          }

          .about-strip-content {
            padding: 28px 20px;
          }

          .about-strip-title {
            font-size: 26px;
          }

          .about-strip-text {
            font-size: 16px;
            line-height: 24px;
          }
        }
      `}</style>
    </>
  );
}
